<template src="./index.html"></template>
<script>
import { shlc_page, shlc_save, shlc_selectRoleUserList, queryAllCompanys } from '../../../../api/shlc.js';
import { groupList } from '../../../../api/organization.js';
import { DeptChildrenUser } from '../../../../api/personnel.js';
import { getdata } from './data.js';
import { getMbData } from './data-mb.js';
export default {
	name: 'AuditProcess',
	components: {},
	data: function() {
		return {
			guanlianjiueshe: false,
			tablekey: 0,
			chooseindex: 0,
			taballData: [
				{
					label: '审核流程',
					flowType: 'PAPER_FLOW'
				}
			],
			headData: 'hls' == localStorage.getItem('nssbCompany') ? getdata().headData : getMbData().headData,
			tableData: [],
			data: [],
			radiocheck: [],
			//数据下标
			sjxiabiao: '',
			chooseFlowType: 'PAPER_FLOW',
			//公司
			choosecompany: '',
			companys: [],
			relationApplyUsers: false,
			leftCompanyData: [],
			allowDrag: null,
			allowDrop: null,
			renameInput: '',
			deptType: '',
			companyId: '',
			choosetreeid: '',
			ancestors: [], //当前节点的父级关联关系（id）
			parentNames: [], //当前节点的父级关联关系（名称）
			shaidiag: false,
			userHeadData: 'hls' == localStorage.getItem('nssbCompany') ? getdata().userHeadData : getMbData().userHeadData,
			pagination: 'hls' == localStorage.getItem('nssbCompany') ? getdata().pagination : getMbData().pagination,
			userTableData: 'hls' == localStorage.getItem('nssbCompany') ? getdata().userTableData : getMbData().userTableData,
			userOutlist: [],
			activeSearch: '',
			tablekey: 1,
			userNameSeach: '',
			nssbCompany: localStorage.getItem('nssbCompany'),
			Selected: []
		};
	},
	mounted() {},
	created() {
		if ('hls' == this.nssbCompany) {
			this.queryAllCompanys();
		} else {
			this.forupdatecompany();
		}
	},
	methods: {
		checkChange(currObj, isChecked) {
			if (isChecked) {
				// 选中之后我们就重新设置下选中的节点（只设置当前选中的节点，即单选）
				this.$refs.Tree.setCheckedNodes([currObj]);
			}
		},
		func(value, id, key) {
			for (let a = 0; a < value.length; a++) {
				if (value[a].children != null || value[a].children) {
					this.func(value[a].children, id, key + ',' + value[a].id);
				}
				if (value[a].id == id) {
					return (this.suoshy = key.split(',').splice(1, key.length - 1));
				}
			}
		},
		//选择人员保存
		tianjiajues() {
			if (this.radiocheck == null || this.radiocheck == '') {
				this.$message.error('请选择角色');
			} else {
				let chooseitem = { roleName: [], id: [], relationUserNames: [] };
				this.data.forEach(item => {
					getchildren(item, this.radiocheck);
				});
				function getchildren(data, id) {
					if (data.children.length != 0) {
						data.children.forEach(item => {
							id.map(item1 => {
								if (item.children) {
									getchildren(item.children);
								} else {
									if (item.id == item1) {
										chooseitem.roleName.push(item.roleName);
										chooseitem.id.push(item.id);
										chooseitem.relationUserNames.push(item.relationUserNames);
									}
								}
							});
						});
					} else {
						id.map(item => {
							if (data.id == item) {
								chooseitem.roleName.push(data.roleName);
								chooseitem.id.push(data.id);
								chooseitem.relationUserNames.push(data.relationUserNames);
							}
						});
					}
				}
				let newarr = JSON.parse(JSON.stringify(this.tableData));
				newarr[this.sjxiabiao].name = chooseitem.roleName.join(',');
				newarr[this.sjxiabiao].relationId = chooseitem.id.join(',');
				newarr[this.sjxiabiao].userNames = chooseitem.relationUserNames.join(',');
				this.tableData = newarr;
				this.guanlianjiueshe = false;
			}
		},
		//角色选择弹框
		tanchujiuesxuanz(id) {
			this.sjxiabiao = '';
			shlc_selectRoleUserList().then(res => {
				this.data = res.data.data;
				this.sjxiabiao = id;
				this.guanlianjiueshe = true;
			});
		},
		//保存
		baocheng() {
			let panduan = true;
			for (var i = 1; i <= this.tableData.length; i++) {
				if (this.tableData[i - 1].relationId == '') {
					panduan = false;
					this.$message.error('请选择第' + i + '行用户角色');
					break;
				}
				if (this.tableData[i - 1].applayPlatform == '' && this.tableData[i - 1].applayEmail == '') {
					panduan = false;
					this.$message.error('请选择第' + i + '行审核方式');
					break;
				}
				if (this.tableData[i - 1].passType == '') {
					this.$message.error('请选择第' + i + '行审核规则');
					panduan = false;
					break;
				}
			}
			if (panduan) {
				let flowNodes = this.tableData.map(v => {
					delete v.id;
					if ('hls' == this.nssbCompany) {
						v.flowType = this.chooseFlowType + '_' + this.choosecompany;
					} else {
						v.flowType = this.chooseFlowType;
					}
					return v;
				});
				let params = { flowNodes, type: this.chooseFlowType };
				if ('hls' == this.nssbCompany) {
					params = { flowNodes, type: this.chooseFlowType + '_' + this.choosecompany, companyNo: this.choosecompany };
				}
				shlc_save(params).then(res => {
					if (res.data.data) {
						this.$message.success('保存成功');
						this.forupdatecompany();
					} else {
						this.$message.error('保存失败！' + res.data.msg);
					}
				});
			}
		},
		//删除
		shanchuhang(xiabiao) {
			this.$delete(this.tableData, xiabiao);
		},
		chooseTab(item, index) {
			this.chooseindex = index;
			this.chooseFlowType = item.flowType;
			this.forupdatecompany();
		},
		companyChange(item) {
			this.forupdatecompany();
		},
		queryAllCompanys() {
			queryAllCompanys().then(res => {
				this.companys = res.data.data;
				this.choosecompany = res.data.data[0].companyNo;
				this.forupdatecompany();
			});
		},
		//查询
		forupdatecompany() {
			let params = { flowType: this.chooseFlowType };
			if ('hls' == this.nssbCompany) {
				params = { flowType: this.chooseFlowType + '_' + this.choosecompany, companyNo: this.choosecompany };
			}
			shlc_page(params).then(res => {
				this.tableData = res.data.data.records;
			});
		},
		addhang() {
			let panduan = true;
			for (var i = 1; i <= this.tableData.length; i++) {
				if (this.tableData[i - 1].relationId == '') {
					panduan = false;
					break;
				}
				if (this.tableData[i - 1].applayPlatform == '' && this.tableData[i - 1].applayEmail == '') {
					panduan = false;
					break;
				}
				if (this.tableData[i - 1].passType == '') {
					panduan = false;
					break;
				}
			}
			if (panduan) {
				this.tableData.push({
					applayEmail: '',
					applayPlatform: '',
					flowType: '',
					id: '',
					name: '',
					nodeIndex: '',
					passType: '0',
					relationId: '',
					relationType: '',
					type: '',
					userNames: '',
					nodeIndex: this.tableData.length+1
				});
			} else {
				this.$message.error('未完成当前审批流，不允许继续添加审批流');
			}
		},
		addCompanyUser(item) {
			this.sjxiabiao = item;
			this.Selected = [];
			this.leftCompanysTreeQuery();
			this.relationApplyUsers = true;
		},
		dragleave(draggingNode, dropNode, ev) {},
		//获取弹窗左侧公司列表
		leftCompanysTreeQuery() {
			groupList().then(res => {
				if (res.data.data) {
					this.leftCompanyData = res.data.data;
					this.choosetreeid = this.leftCompanyData[0].id;
					this.forchooseitem('', this.leftCompanyData[0]);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		forchooseitem(node, data) {
			//点击列表中的某一项获取到的数据
			this.renameInput = data.name; //节点名称赋值
			this.deptType = data.deptType; //节点类型
			this.companyId = data.companyId;
			this.choosetreeid = data.id;
			let num = 0;

			if (this.Selected.length > 0) {
				this.$refs.userTablebox.getSelectionval().map(item => {
					this.Selected.map((item1, index) => {
						if (item.userId != item1.userId && index == this.Selected.length - 1 && num == 0) {
							this.Selected.push(item);
						} else if (item.userId == item1.userId) {
							num++;
						}
					});
				});
			} else {
				this.Selected.push(...this.$refs.userTablebox.getSelectionval());
			}
			if (data.parentNames) {
				this.parentNames = data.parentNames.split('-'); //当前节点的父级关联关系（名称）
			}
			if (data.ancestors) {
				this.ancestors = data.ancestors.split(','); //当前节点的父级关联关系（id）
			}
			this.ancestors.push(this.choosetreeid); //push当前id
			if (node) {
				this.clickSearch(true);
			} else {
				this.clickSearch(false);
			}
		},
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			this.userHeadData = e.chooselist;
			this.userOutlist = e.nochooselist;
			this.shaidiag = false;
		},
		sizechange(e) {
			//页码切换
			this.pagination.pageSize = e;
			this.ChildrenUser(); //调用分页查询
		},
		currentChange(e) {
			//页码切换
			this.pagination.pageNum = e;
			this.ChildrenUser(); //调用分页查询
		},
		ChildrenUser() {
			let params = {
				current: this.pagination.pageNum,
				deptId: this.choosetreeid,
				size: this.pagination.pageSize,
				query: this.userNameSeach //搜索框信息
			};
			DeptChildrenUser(params).then(res => {
				if (res.data.code == 1) {
					this.userTableData = res.data.data.records;
					this.pagination.total = parseFloat(res.data.data.total);
					this.$nextTick(() => {
						if (this.Selected.length != 0) {
							let list = [];
							this.userTableData.map(item => {
								this.Selected.map(item1 => {
									if (item.userId == item1.userId) {
										list.push(item);
									}
								});
							});
							this.$refs.userTablebox.toggleSelection(list);
						}
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		clickSearch(e) {
			//点击搜索
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			if (!e) {
				this.Selected = [];
			}
			this.ChildrenUser(); //调用搜索按钮
		},
		addUserToApply() {
			let num = 0;
			if (this.Selected.length > 0) {
				this.$refs.userTablebox.getSelectionval().map(item => {
					this.Selected.map((item1, index) => {
						if (item.userId != item1.userId && index == this.Selected.length - 1 && num == 0) {
							this.Selected.push(item);
						} else if (item.userId == item1.userId) {
							num++;
						}
					});
				});
			} else {
				this.Selected.push(...this.$refs.userTablebox.getSelectionval());
			}
			if (this.$emptyandnull(this.Selected)) {
				this.$message.error('请选择审核员');
				return false;
			}
			let idArr = [];
			let nameArr = [];
			this.Selected.forEach(e => {
				idArr.push(e.userId);
				nameArr.push(e.nickName);
			});
			this.$refs.userTablebox.toggleSelection([]);
			let newarr = JSON.parse(JSON.stringify(this.tableData));
			newarr[this.sjxiabiao].relationId = idArr.join(',');
			newarr[this.sjxiabiao].userNames = nameArr.join(',');
			newarr[this.sjxiabiao].relationType = '3';
			newarr[this.sjxiabiao].companyNo = this.choosecompany;
			this.tableData = newarr;
			this.relationApplyUsers = false;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
